/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Role {
    WORKER = 'WORKER',
    COMPANY_ADMIN = 'COMPANY_ADMIN',
    COMPANY_FIRST_ADMIN = 'COMPANY_FIRST_ADMIN',
    RECEPTIONIST = 'RECEPTIONIST',
    SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
}
